{
	"name": "@cloudillo/ideallo-app",
	"version": "0.8.20",
	"private": true,
	"description": "Ideallo collaborative whiteboard",
	"type": "module",
	"main": "src/index.js",
	"scripts": {
		"ts": "tsgo --noEmit",
		"ts-test": "tsgo --noEmit -p tsconfig.test.json",
		"ts-watch": "tsgo --noEmit --watch",
		"build": "pnpm run ts && cross-env NODE_ENV=production node esbuild.config.js",
		"watch": "node esbuild.config.js --watch",
		"test": "NODE_OPTIONS=\"--experimental-vm-modules\" jest",
		"test:watch": "NODE_OPTIONS=\"--experimental-vm-modules\" jest --watch",
		"test:coverage": "NODE_OPTIONS=\"--experimental-vm-modules\" jest --coverage",
		"clean": "rimraf .cache dist/assets-*"
	},
	"author": "Cloudillo <info@cloudillo.org>",
	"license": "LGPL-3.0-or-later",
	"devDependencies": {
		"@cloudillo/canvas-text": "workspace:^",
		"@cloudillo/canvas-tools": "workspace:^",
		"@cloudillo/core": "workspace:^",
		"@cloudillo/crdt": "workspace:^",
		"@cloudillo/fonts": "workspace:^",
		"@cloudillo/react": "workspace:^",
		"@symbion/opalui": "^0.16.0",
		"@symbion/runtype": "^1.3.1",
		"@testing-library/dom": "^10.4.2",
		"@testing-library/react": "^16.3.3",
		"@types/jest": "^30.0.0",
		"@types/react": "^19.3.0",
		"@types/react-dom": "^19.3.0",
		"@typescript/native": "npm:typescript@^7.0.2",
		"cross-env": "^10.1.0",
		"esbuild": "^0.28.2",
		"i18next": "^26.5.2",
		"jest": "^30.5.2",
		"jest-environment-jsdom": "^30.5.2",
		"jotai": "^3.0.1",
		"quill": "^2.0.3",
		"react": "19.3.1",
		"react-dom": "19.3.1",
		"react-i18next": "^17.1.0",
		"react-icons": "^5.7.0",
		"react-router-dom": "^7.18.4",
		"react-svg-canvas": "^0.1.9",
		"react-yjs": "^2.0.1",
		"rimraf": "^6.1.3",
		"ts-jest": "^29.4.15",
		"tslib": "^2.8.1",
		"typescript": "npm:@typescript/typescript6@^6.0.2",
		"y-indexeddb": "^9.0.12",
		"y-protocols": "^1.0.7",
		"y-quill": "^1.0.0",
		"y-websocket": "^3.1.0",
		"yjs": "^13.6.33"
	}
}
